<template>
  <div class="data-select" v-click-outside="onClickOutside">
    <div v-if="!value">
      <div class="add" @click="onClick()" :class="{ active }">
        <div class="icon">
          <img src="~@/assets/icons/add.svg" />
        </div>
        <span>Select</span>
      </div>
    </div>

    <div v-if="value">
      <div
        class="add"
        @click="onClick()"
        :class="{ active, 'type-icon': type === 'action' }"
      >
        <div
          class="circle icon img"
          :class="getClassname(value)"
          v-if="type === 'action'"
        ></div>
        <div class="circle" v-if="type !== 'action' && value.initials">
          {{ value.initials }}
        </div>
        <div class="text">
          <h4 :class="{ noMargin: !value.meta }" v-tooltip="{content: value.name, delay: 200, placement: 'right'}">{{ value.name }}</h4>
          <p v-if="value.meta">{{ value.meta }}</p>
        </div>
        <img
          class="clear"
          src="~@/assets/icons/clear.svg"
          @click.stop.prevent="select(value, 'remove')"
        />
      </div>
    </div>

    <div class="select-dropdown" :class="{ active }">
      <div class="search-panel" v-if="type !== 'action'">
        <input ref="search_input" type="text" v-model="search_term" placeholder="Search" />
        <img
          v-if="search_term"
          class="clear"
          src="~@/assets/icons/clear.svg"
          @click.stop.prevent="clearSearch()"
        />
      </div>

      <div class="scroll-zone" ref="dropdown">
        <div
          v-for="(item, index) of the_data"
          :key="`dropdown-item-${uuid}-${index}`"
          @click="select(item, 'add')"
          class="item"
          :class="{
            selected: value && item.id === value.id,
            'type-icon': type === 'action',
          }"
        >
          <div
            class="circle icon img"
            :class="getClassname(item)"
            v-if="type === 'action'"
          ></div>
          <div class="circle" v-if="type !== 'action' && item.initials">
            {{ item.initials }}
          </div>
          <div class="text">
            <h4 :class="{ noMargin: !item.meta }" v-tooltip="{content: item.name, delay: 200}">{{ item.name }}</h4>
            <p v-if="item.meta">{{ item.meta }}</p>
          </div>
        </div>
      </div>

      <div v-if="allowAdd" class="plus-btn" @click="showNewForm()">
        <img src="~@/assets/icons/add.svg" />
        <span>Add {{ search_term ? search_term : 'new' }}</span>
      </div>
    </div>

    <div
      class="new-form"
      :class="{ active: active && newMode }"
      v-show="allowAdd && type.includes('user')"
    >
      <material-input
        v-model="newUser.firstName"
        type="text"
        label="First name"
        :required="true"
        name="First name"
      />
      <material-input
        v-model="newUser.lastName"
        type="text"
        label="Last name"
        :required="true"
        name="Last name"
      />
      <dropdown
        :options="user_options"
        :value="newUser.jobTitle"
        :onChange="val => (newUser.jobTitle = val)"
        placeholder="Role"
        :required="true"
      />

      <b-form-checkbox
        v-show="app_user_role === 'SuperAdmin'"
        v-model="newUser.inviteUser"
        >Invite this user to Acada</b-form-checkbox
      >

      <material-input
        v-show="newUser.inviteUser && app_user_role === 'SuperAdmin'"
        v-model="newUser.email"
        type="email"
        label="Email"
        :required="newUser.inviteUser && app_user_role === 'SuperAdmin'"
        name="Email"
        ref="newUserEmail"
      />

      <a class="button" @click="addNewUser()" :disabled="addUserFormValid()"
        >Add</a
      >
    </div>

    <div
      class="new-form"
      :class="{ active: active && newMode }"
      v-show="allowAdd && type === 'suppliers'"
    >
        <material-input
          v-model="newSupplier.name"
          style="width: 100%"
          class="mr-3"
          type="text"
          label="Supplier Name"
          :required="true"
          name="SupplierName"
        />

<!--        <material-input-->
<!--          v-model="newSupplier.description"-->
<!--          style="width: 100%"-->
<!--          type="text"-->
<!--          label="Initials"-->
<!--          :required="true"-->
<!--          name="Initials"-->
<!--          :maxChars="3"-->
<!--        />-->

      <material-input
        v-model="newSupplier.internalCode"
        style="width: 100%"
        type="text"
        label="Internal Ref. Code"
        :required="false"
        name="Internal Ref. Code"
      />
<!--      <dropdown-->
<!--        :options="supplier_options"-->
<!--        :value="newSupplier.categoryId"-->
<!--        :onChange="val => (newSupplier.categoryId = val)"-->
<!--        placeholder="Category"-->
<!--        :required="true"-->
<!--      />-->

      <a
        class="button"
        @click="addNewSupplier()"
        :disabled="addSupplierFormValid()"
        >Add</a
      >
    </div>
  </div>
</template>

<script>
import {v4 as uuid} from 'uuid';
import MaterialInput from './MaterialInput';
import Dropdown from './Dropdown';

export default {
  name: 'DataSelect',
  data() {
    return {
      uuid: uuid(),
      search_term: '',
      filter_by: '',
      debounce_timer: null,
      newMode: false,
      newUser: {
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        inviteUser: false,
      },
      newSupplier: {
        name: '',
        description: '',
        categoryId: null,
      },
      user_options: [
        { value: 'Legal', text: 'Legal' },
        { value: 'Finance', text: 'Finance' },
        { value: 'Business', text: 'Business' },
        { value: 'Procurement', text: 'Procurement' },
        { value: 'Other', text: 'Other' },
      ],
    };
  },
  props: {
    type: String,
    changeHandler: Function,
    value: Object,
    filterIds: Array,
    arg: String,
    allowAdd: Boolean,
  },
  computed: {
    supplier_options() {
      return Object.keys(this.$store.getters.categories).map(key => {
        const cat = this.$store.getters.categories[key];
        return { text: cat.name, value: cat.id };
      });
    },
    the_data() {
      let the_data = [];

      switch (this.type) {
        case 'suppliers':
          the_data = Object.values(this.$store.getters.suppliers).sort(
            (a, b) => {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 1;
            }
          );
          break;
        case 'action':
          the_data = this.$store.getters.action_types;
          break;
        case 'users':
        default:
          the_data = Object.values(this.$store.getters.users)
            .filter(user => {
              // if the current user is not a SuperAdmin, filter out the SuperAdmins
              if (this.app_user.role !== 'SuperAdmin') {
                return user.role !== 'SuperAdmin';
              }
              return true;
            })
            .sort((a, b) => {
              if (a.firstName === b.firstName) {
                if (a.lastName < b.lastName) {
                  return -1;
                }
                return 1;
              } else if (a.firstName < b.firstName) {
                return -1;
              }
              return 1;
            });
          break;
      }

      if (this.type !== 'action') {
        the_data = the_data.filter(item => {
          const name_match = item.name.toLowerCase().includes(this.filter_by);
          const meta_match =
            item.meta && item.meta.toLowerCase().includes(this.filter_by);
          return name_match || meta_match;
        });
      }

      if (this.filterIds && this.filterIds.length) {
        return the_data.filter(item => {
          return (
            !this.filterIds.includes(String(item.id)) &&
            !this.filterIds.includes(Number(item.id))
          );
        });
      } else {
        return the_data;
      }
    },
    data_dropdown() {
      return this.$store.getters.data_dropdown;
    },
    active() {
      if (!this.data_dropdown) {
        return false;
      }
      return this.data_dropdown.active && this.data_dropdown.uuid === this.uuid;
    },
    top() {
      return this.$el.offsetTop;
    },
    app_user() {
      return this.$store.getters.app_user;
    },
    app_user_role() {
      if (!this.app_user) return '';
      return this.app_user.role;
    },
  },
  methods: {
    onClick() {
      if (this.active) {
        this.closeDropdown();
        return;
      }

      this.$refs.dropdown.scrollTo(0, 0);
      this.$store.dispatch('setDataDropdown', {
        active: true,
        uuid: this.uuid,
      });
    },
    onClickOutside() {
      if (this.active) {
        this.closeDropdown();
      }
    },
    closeDropdown() {
      this.reset();
      this.$store.dispatch('setDataDropdown', null);
    },
    select(item, mode) {
      const old_value = this.value;

      this.changeHandler(item, mode, this.arg, old_value);
      this.closeDropdown();
    },
    getClassname(value) {
      return value.name.replace(/ /g, '').toLowerCase();
    },
    debounce_search() {
      if (this.debounce_timer) {
        clearTimeout(this.debounce_timer);
      }

      this.debounce_timer = setTimeout(() => {
        this.debounce_timer = null;
        this.search(this.page, this.perPage);
      }, 350);
    },
    search() {
      // TODO - hook this up with real data
      this.filter_by = this.search_term.toLowerCase();
    },
    clearSearch() {
      this.search_term = '';
    },
    showNewForm() {
      this.newMode = true;
    },
    async addNewUser() {
      try {
        const newUser = Object.assign({}, this.newUser);
        newUser.role = 'User';
        newUser.organizationId = this.$store.getters.org.id;

        if (!this.newUser.inviteUser) {
          delete newUser.email;
        }

        delete newUser.inviteUser;

        const the_new_user = await this.$api.createUser(newUser);
        await this.$store.dispatch('getUser', the_new_user.data.createdUser.id);

        this.reset();
        this.selectNewUser(the_new_user);
      } catch (e) {
        console.error(e);
      }
    },
    emailValid(email) {
      const regex = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );

      const regexPass = regex.test(email);

      return email && regexPass;
    },
    selectNewUser(the_new_user) {
      // auto select the new user
      const id = the_new_user.data.createdUser.id;
      const item = this.the_data.find(user => {
        if (id) {
          return user.id === id;
        } else if (the_new_user.data.createdUser.email && user.email) {
          return the_new_user.data.createdUser.email === user.email;
        }
        return false;
      });

      if (item) {
        this.select(item, 'add');
      }
    },
    addUserFormValid() {
      let formInvalid =
        !this.newUser.firstName ||
        !this.newUser.lastName ||
        !this.newUser.jobTitle;
      let emailFieldInvalid = false;

      if (!formInvalid && this.newUser.inviteUser) {
        emailFieldInvalid = !this.emailValid(this.newUser.email);
      }

      return formInvalid || emailFieldInvalid;
    },
    async addNewSupplier() {
      try {
        const newSupplier = Object.assign({}, this.newSupplier);
        newSupplier.userId = this.$store.getters.app_user.id;
        newSupplier.organizationId = this.$store.getters.org.id;

        const the_new_supplier = await this.$api.createSupplier(newSupplier);
        await this.$store.dispatch('getSuppliers');

        this.reset();
        this.selectNewSupplier(the_new_supplier);
      } catch (e) {
        console.error(e);
      }
    },
    selectNewSupplier(supplier) {
      // auto select the new supplier
      const id = supplier.data.createdSuppliers.id;
      const item = this.the_data.find(s => {
        if (id) {
          return s.id === id;
        }
        return false;
      });

      if (item) {
        this.select(item, 'add');
      }
    },
    addSupplierFormValid() {
      const formInvalid =
        !this.newSupplier.name
        // ||
        // !this.newSupplier.description ||
        // !this.newSupplier.categoryId;
      return formInvalid;
    },
    reset() {
      this.newUser = {
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        inviteUser: false,
      };

      this.newSupplier = {
        name: '',
        description: '',
        categoryId: null,
      };

      this.newMode = false;
    },
  },
  watch: {
    search_term() {
      this.debounce_search();
    },
    active(val) {
      this.search_term = '';
      if(val) {
        this.$refs.search_input.focus();
      }
    },
  },
  components: {
    'material-input': MaterialInput,
    dropdown: Dropdown,
  },
};
</script>
